import AuthService from '../../../services/cognito/auth';
import AccountsService from '../../../services/customer-accounts';
import { clearIndexedDB } from '../../../utils/common';

const userSignup = async (
  emailExistsError,
  setEmailExistsError,
  setAccountSuccessfullyCreated,
  setErrorMessage,
  firstName,
  lastName,
  email,
  phoneNum,
  password,
  onCreationSuccessCallback,
  customerAddress,
  setAccountCreationError,
  anonymousId,
) => {
  if (emailExistsError) setEmailExistsError(false);
  const phoneNumber = `+1${phoneNum?.replace(/[()\s\\-]+/g, '')}`;
  try {
    // cognito creation
    const response = await AuthService.createNewAccount({
      email,
      password,
      givenName: firstName,
      familyName: lastName,
      phoneNumber,
    });
    if (response && !response.userConfirmed) {
      if (setAccountSuccessfullyCreated) {
        setAccountSuccessfullyCreated(true);
      }
      // create customer in commerce tool
      const newCustomer = {
        firstName,
        lastName,
        email,
        password,
        addresses: customerAddress,
      };
      const createResponse = await AccountsService.createCustomer(newCustomer, anonymousId);

      if (createResponse === 'CUSTOMER-008') {
        // Make user to login to save the order placed in an anonymous session
        await AccountsService.login(
          email,
          anonymousId,
        );
      }

      if (onCreationSuccessCallback !== null) {
        onCreationSuccessCallback(email);
      }
      clearIndexedDB();
    }
    throw response;
  } catch (error) {
    if (error.name === 'UsernameExistsException') {
      try {
        await AuthService.authorize({
          username: email,
          password,
        });
        setEmailExistsError(true);
        setAccountCreationError(false);
      } catch (err) {
        if (err.name === 'UserNotConfirmedException') {
          setAccountCreationError(err.name);
          setEmailExistsError(false);
        } else {
          setEmailExistsError(true);
          setAccountCreationError(false);
        }
      }
    } else if (setErrorMessage) {
      setErrorMessage(error.message);
    }
  }
};
export default userSignup;
